<template>
  <div class="l-content">
    <div class="row">
      <div class="col-xs-16 col-xs-offset-1 col-sm-14 col-sm-offset-2">
        <div class="se-statement mb" :style="bgc">
          <div class="se-statement__text-container">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Statement',
  props: ['bg'],
  data () {
    return {
      bgc: {
        backgroundColor: this.bg
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
  .se-statement {
    border-width: 3px;
    border-color: $green-light;
    border-style: solid;
    // border-radius: 8px;
    padding-top: 8%;
    padding-bottom: 8%;
    padding-left: 8%;
    padding-right: 8%;
    @media (min-width: 768px) {
      padding-left: 50px;
      padding-right: 50px;
      padding-top: 45px;
      padding-bottom: 45px;
    }
    h3 {
      color: $green-light;
      margin: 0;
    }
    a {
      color: $green-light;
    }
    .cta-button {
      color: $white;
    }
    p {
      color: $green-light;
      margin-top: 18px;
      margin-bottom: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Statement.vue